import { RDUsdaUnderservedSmall } from '@cibo/core'
import { ResourceDetailFeatureTaskEditorProps } from '@cibo/ui'
import { MulticheckEditor } from '../MulticheckEditor'

const keys = [
  'racialEthnicMinorityFarmer',
  'veteran',
  'beginnerFarmer',
  'limitedResources',
  'womanFarmer',
  'smallScale',
  'none',
]
/**
 * We assume that there is only ever a single detail requirement for this component.
 */
export const RDUsdaUnderservedSmallTaskEditor = (
  props: ResourceDetailFeatureTaskEditorProps<RDUsdaUnderservedSmall>
) => {
  return (
    <MulticheckEditor<RDUsdaUnderservedSmall>
      keys={keys}
      ns="@cibo/RDUsdaUnderservedSmallTaskEditor"
      detailKey="usdaUnderservedSmall"
      {...props}
    />
  )
}
